import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { apiSubirExcel, routeFindUserByRol } from "./constants";

const modalOverlayStyle = {
  position: "fixed",
  inset: 0,
  backgroundColor: "rgba(0, 0, 0, 0.55)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 1000,
};

const modalStyle = {
  backgroundColor: "#ffffff",
  borderRadius: "8px",
  boxShadow: "0 8px 30px rgba(0, 0, 0, 0.25)",
  maxWidth: "420px",
  padding: "28px",
  textAlign: "center",
  width: "calc(100% - 40px)",
};

const progressTrackStyle = {
  backgroundColor: "#e5e7eb",
  borderRadius: "999px",
  height: "12px",
  margin: "20px 0 8px",
  overflow: "hidden",
};



export const UploadExcel = () => {
  const [archivo, setArchivo] = useState(null);
  const [matriculaAdmin, setMatriculaAdmin] = useState("");
  const [administradores, setAdministradores] = useState([]);
  const [cargandoAdministradores, setCargandoAdministradores] = useState(true);
  const [errorAdministradores, setErrorAdministradores] = useState("");
  const [message, setMessage] = useState("");
  const [estadoCarga, setEstadoCarga] = useState(null);
  const [mensajeCarga, setMensajeCarga] = useState("");
  const [porcentajeCarga, setPorcentajeCarga] = useState(0);
  const navigate = useNavigate();
  const estaSubiendo = estadoCarga === "subiendo";

  useEffect(() => {
    const fetchAdministradores = async () => {
      try {
        const response = await axios.get(routeFindUserByRol, {
          params: { role: "Admin" },
        });
        const lista = response.data?.data ?? response.data ?? [];
        setAdministradores(Array.isArray(lista) ? lista : []);
      } catch (error) {
        console.error("Error al cargar administradores:", error);
        setErrorAdministradores(
          "No fue posible cargar la lista de administradores.",
        );
      } finally {
        setCargandoAdministradores(false);
      }
    };

    fetchAdministradores();
  }, []);


  const handleArchivoChange = (event) => {
    setArchivo(event.target.files[0]);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setMessage("");

    if (!archivo || !matriculaAdmin) {
      setMessage("Selecciona un administrador y un archivo Excel.");
      return;
    }

    setEstadoCarga("subiendo");
    setMensajeCarga("Subiendo el archivo Excel...");
    setPorcentajeCarga(0);

    try {
      const formData = new FormData();
      formData.append("archivo", archivo);
      formData.append("matricula_admin", matriculaAdmin);

      const response = await axios.post(apiSubirExcel, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        onUploadProgress: (progressEvent) => {
          if (!progressEvent.total) {
            return;
          }

          const porcentaje = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total,
          );
          setPorcentajeCarga(porcentaje);
          setMensajeCarga(
            porcentaje === 100
              ? "Archivo enviado. Procesando en el servidor..."
              : "Subiendo el archivo Excel...",
          );
        },
      });

      if (response.data.success) {
        setEstadoCarga("exito");
        setMensajeCarga(
          response.data.message || "El archivo Excel se subió correctamente.",
        );
      } else {
        setEstadoCarga("error");
        setMensajeCarga(
          response.data.message || "Hubo un error al subir el archivo Excel.",
        );
      }
    } catch (error) {
      console.error("Error uploading Excel file:", error);
      setEstadoCarga("error");
      setMensajeCarga(
        error.response?.data?.message ||
          error.response?.data?.error ||
          "Hubo un error al subir el archivo Excel.",
      );
    }
  };

  const handleCerrarResultado = () => {
    if (!estaSubiendo) {
      setEstadoCarga(null);
      setMensajeCarga("");
    }
  };

  const handleRegresarButton = () => {
    if (!estaSubiendo) {
      navigate("/admin-home");
    }
  };

  return (
    <div className="full-page">
      <div className="container1">
        <h2>Subir Archivo Excel</h2>
        {message && <p>{message}</p>}
        <form onSubmit={handleSubmit}>
          <div>
            <label htmlFor="matriculaAdmin">Administrador:</label>
            <select
              id="matriculaAdmin"
              value={matriculaAdmin}
              onChange={(event) => setMatriculaAdmin(event.target.value)}
              disabled={cargandoAdministradores || estaSubiendo}
              required
            >
              <option value="">
                {cargandoAdministradores
                  ? "Cargando administradores..."
                  : "-- Selecciona un administrador --"}
              </option>
              {administradores.map((administrador) => (
                <option
                  key={administrador.id ?? administrador.matricula}
                  value={administrador.matricula}
                >
                  {administrador.matricula} - {administrador.nombre}{" "}
                  {administrador.apellido}
                </option>
              ))}
            </select>
            {errorAdministradores && <p>{errorAdministradores}</p>}
            {!cargandoAdministradores &&
              !errorAdministradores &&
              administradores.length === 0 && (
                <p>No hay administradores registrados.</p>
              )}
          </div>
          <div>
            <label htmlFor="archivo">Selecciona un archivo Excel:</label>
            <input
              type="file"
              id="archivo"
              name="archivo"
              accept=".xlsx, .xls"
              onChange={handleArchivoChange}
              disabled={estaSubiendo}
              required
            />
          </div>
          <div className="ingresar-mat">
            <button
              type="submit"
              disabled={
                cargandoAdministradores ||
                administradores.length === 0 ||
                estaSubiendo
              }
            >
              {estaSubiendo ? "Subiendo..." : "Subir Archivo"}
            </button>
          </div>
        </form>
        <div className="underline2"></div>
        <div className="return-home">
          <span onClick={handleRegresarButton}>Regresar Home</span>
        </div>
      </div>

      {estadoCarga && (
        <div style={modalOverlayStyle} role="presentation">
          <div
            style={modalStyle}
            role="dialog"
            aria-modal="true"
            aria-labelledby="upload-status-title"
          >
            <h3 id="upload-status-title">
              {estadoCarga === "subiendo" && "Carga en proceso"}
              {estadoCarga === "exito" && "Carga completada"}
              {estadoCarga === "error" && "No se pudo completar la carga"}
            </h3>
            <p>{mensajeCarga}</p>

            {estaSubiendo && (
              <>
                <div style={progressTrackStyle}>
                  <div
                    style={{
                      backgroundColor: "#2563eb",
                      height: "100%",
                      transition: "width 0.2s ease",
                      width: `${porcentajeCarga}%`,
                    }}
                  />
                </div>
                <p>
                  {porcentajeCarga > 0
                    ? `${porcentajeCarga}% enviado`
                    : "Preparando archivo..."}
                </p>
              </>
            )}

            {!estaSubiendo && (
              <button type="button" onClick={handleCerrarResultado}>
                Cerrar
              </button>
            )}
          </div>
        </div>
      )}
    </div>
  );
};
